import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Select as Select$1 } from 'baseui/select';
import { mergeOverrides } from '../../../overrides.js';
import 'baseui';
import '../../../theme/olx-theme/base-theme.js';
import '../../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../../theme/utils.js';
import '../../../theme/types.js';
import { StyledIconsContainer, StyledSelectArrow } from './styled-components.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getStyles = ({ $theme, $isOpen, $isFocused, $isPseudoFocused }, element) => {
  switch (element) {
    case "ControlContainer":
      return __spreadValues({
        paddingLeft: $theme.space[16],
        paddingRight: $theme.space[16],
        paddingTop: $theme.space[10],
        paddingBottom: $theme.space[10],
        borderTopWidth: $theme.space[2],
        borderTopColor: $theme.colors["background-global-secondary"],
        borderBottomWidth: $theme.space[2],
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderBottomLeftRadius: $theme.radii[4],
        borderBottomRightRadius: $theme.radii[4]
      }, ($isFocused || $isOpen || $isPseudoFocused) && {
        borderBottomColor: $theme.colors["background-brand-primary"],
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      });
    case "Dropdown":
      return {
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: $theme.colors["background-global-secondary"],
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: $theme.radii[4],
        borderBottomRightRadius: $theme.radii[4],
        boxShadow: $theme.shadow[16]
      };
    case "DropdownListItem":
      return __spreadProps(__spreadValues({}, $theme.typography.p2), {
        paddingTop: $theme.space[12],
        paddingBottom: $theme.space[12],
        backgroundColor: "transparent",
        color: "inherit",
        userSelect: "none"
      });
    case "Placeholder":
      return {
        userSelect: "none",
        pointerEvents: "none"
      };
    case "Popover.Body":
      return {
        zIndex: $theme.zIndices.popover,
        boxShadow: "none"
      };
    case "ValueContainer":
      return {
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0
      };
    case "SingleValue":
      return {
        height: "auto",
        marginLeft: 0,
        marginRight: $theme.space[2]
      };
    default:
      return {};
  }
};
const Select = forwardRef((_a, ref) => {
  var _b = _a, { overrides, searchable = true, $style } = _b, props = __objRest(_b, ["overrides", "searchable", "$style"]);
  const resolvedStyle = useResolvedStyle($style);
  return jsx(Select$1, __spreadValues({ multi: false, clearable: false, backspaceRemoves: false, inputRef: ref, overrides: mergeOverrides({
    Root: {
      style: (styleProps) => mergeStyles(getStyles(styleProps, "Root"), resolvedStyle)
    },
    ControlContainer: {
      style: (styleProps) => getStyles(styleProps, "ControlContainer")
    },
    Dropdown: {
      style: (styleProps) => getStyles(styleProps, "Dropdown")
    },
    DropdownListItem: {
      style: (styleProps) => getStyles(styleProps, "DropdownListItem")
    },
    IconsContainer: {
      component: StyledIconsContainer
    },
    Placeholder: {
      style: (styleProps) => getStyles(styleProps, "Placeholder")
    },
    Popover: {
      props: {
        overrides: {
          Body: {
            style: (styleProps) => getStyles(styleProps, "Popover.Body")
          }
        }
      }
    },
    ClearIcon: {
      props: {
        size: 20
      }
    },
    SelectArrow: {
      component: StyledSelectArrow
    },
    ValueContainer: {
      style: (styleProps) => getStyles(styleProps, "ValueContainer")
    },
    SingleValue: {
      style: (styleProps) => getStyles(styleProps, "SingleValue")
    },
    Input: {
      props: __spreadValues({}, !searchable && { readOnly: true })
    }
  }, overrides), searchable }, props));
});

export { Select };
